export default [
	{
		key: 'Video to storyboard',
		value: 'VIDEOTOSTORYBOARD',
		credits: 4,
		description: `Generates a storyboard from a video ad.`,
		adDescription: 'Turn this ad into a ready-to-use storyboard',
		uses: [
			'Useful for briefing editors',
			'Great for prompting AI video tools like Sora/VEO',
		],
		required: ['video-ad'],
		tips: [
			'Use this storyboard to brief editors or guide AI video tools like Veo or Sora.',
			'Copy it as JSON or Markdown to instantly generate video scenes or shot lists.',
			`Remember, garbage-in is garbage-out. Incoherent ad x brief will generate lousy info. You don't want Alex Hormozi x Magicspoon and expect good results.`,
		],
		icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 4C4 2.89543 4.89543 2 6 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H6C4.89543 22 4 21.1046 4 20V4ZM6 16H18V4H6L6 16ZM18 18H6V20H18V18Z" fill="black"/>
<path d="M12.1845 7.40787C12.2813 7.35949 12.3598 7.28103 12.4081 7.18426L13.0531 5.89443C13.2373 5.5259 13.7632 5.5259 13.9475 5.89443L14.5924 7.18426C14.6408 7.28103 14.7192 7.35949 14.816 7.40787L16.1058 8.05279C16.4744 8.23705 16.4744 8.76295 16.1058 8.94721L14.816 9.59213C14.7192 9.64051 14.6408 9.71897 14.5924 9.81574L13.9475 11.1056C13.7632 11.4741 13.2373 11.4741 13.0531 11.1056L12.4081 9.81574C12.3598 9.71897 12.2813 9.64051 12.1845 9.59213L10.8947 8.94721C10.5262 8.76295 10.5262 8.23705 10.8947 8.05279L12.1845 7.40787Z" fill="black"/>
<path d="M8.5775 11.7114C8.63556 11.6824 8.68263 11.6353 8.71166 11.5772L9.23194 10.5367C9.3425 10.3155 9.65804 10.3155 9.7686 10.5367L10.2889 11.5772C10.3179 11.6353 10.365 11.6824 10.423 11.7114L11.4636 12.2317C11.6847 12.3422 11.6847 12.6578 11.4636 12.7683L10.423 13.2886C10.365 13.3176 10.3179 13.3647 10.2889 13.4228L9.7686 14.4633C9.65804 14.6845 9.3425 14.6845 9.23195 14.4633L8.71166 13.4228C8.68263 13.3647 8.63556 13.3176 8.5775 13.2886L7.53693 12.7683C7.31582 12.6578 7.31581 12.3422 7.53693 12.2317L8.5775 11.7114Z" fill="black"/>
</svg>
`,
	},
	{
		key: 'Ad concept',
		credits: 1,
		value: 'CONCEPT',
		description:
			'Generate brand-ready ad concept with 4 hooks shaped by your brief.',
		adDescription: 'Generate ad concept with 4 hooks',
		uses: ['Great for prototyping ad hooks'],
		required: ['brief'],
		tips: [
			'Use these hooks and angles to plan your next ad.',
			'Copy the JSON or Markdown and paste it into ChatGPT or your AI tool to turn ideas into full scripts.',
			'Not getting the output you need? Modify your brand and fill in as much info as possible to get the best results.',
			'Remember, garbage-in is garbage-out. Incomplete or incorrect brief info will generate lousy concepts and hooks.',
		],
		icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 18H7M4 12H9M4 6H20M17 10L18.5 13.5L22 15L18.5 16.5L17 20L15.5 16.5L12 15L15.5 13.5L17 10Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
	},
	// {
	// 	key: 'Video script',
	// 	credits: 4,
	// 	value: 'VIDEO',
	// 	description:
	// 		'Create a video script that follows your brief, remixed from the source ad’s idea.',
	// 	adDescription: `Adapt the ad to your client's brief`,
	// 	requires: ['video-ad', 'brief'],
	// 	icon: `<svg
	// 				width="24"
	// 				height="24"
	// 				viewBox="0 0 24 24"
	// 				fill="none"
	// 				xmlns="http://www.w3.org/2000/svg"
	// 			>
	// 				<path
	// 					d="M11.85 8H12.15M7.85 12H8.15M15.85 12H16.15M11.85 16H12.15M21 21H13M12.75 8C12.75 8.41421 12.4142 8.75 12 8.75C11.5858 8.75 11.25 8.41421 11.25 8C11.25 7.58579 11.5858 7.25 12 7.25C12.4142 7.25 12.75 7.58579 12.75 8ZM8.75 12C8.75 12.4142 8.41421 12.75 8 12.75C7.58579 12.75 7.25 12.4142 7.25 12C7.25 11.5858 7.58579 11.25 8 11.25C8.41421 11.25 8.75 11.5858 8.75 12ZM16.75 12C16.75 12.4142 16.4142 12.75 16 12.75C15.5858 12.75 15.25 12.4142 15.25 12C15.25 11.5858 15.5858 11.25 16 11.25C16.4142 11.25 16.75 11.5858 16.75 12ZM12.75 16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16C11.25 15.5858 11.5858 15.25 12 15.25C12.4142 15.25 12.75 15.5858 12.75 16ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
	// 					stroke="currentColor"
	// 					stroke-width="2"
	// 					stroke-linecap="round"
	// 				/>
	// 			</svg>`,
	// },
	{
		key: 'Ad copy',
		value: 'COPY',
		credits: 1,
		description: `Generates ad copy variations based on a source ad but modelled after your brief.`,
		adDescription: `Remix this ad's copy`,
		uses: ['Perfect for testing alternative copy'],
		required: ['video-ad', 'brief'],
		tips: [
			'Use this copy in your ads, captions, or landing pages.',
			'You can copy it into any editor or LLM to refine tone, test versions, or make new variations fast.',
		],
		icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M17.2071 4.2072L19.7929 6.79299C20.1834 7.18351 20.1834 7.81668 19.7929 8.2072L8.29289 19.7072C8.10536 19.8947 7.851 20.0001 7.58579 20.0001H4V16.4143C4 16.1491 4.10536 15.8947 4.29289 15.7072L15.7929 4.2072C16.1834 3.81668 16.8166 3.81668 17.2071 4.2072Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	<path d="M4.75518 5.15769C4.65005 4.94744 4.35001 4.94744 4.24488 5.15769L3.59168 6.4641C3.56407 6.51931 3.51931 6.56407 3.4641 6.59168L2.15769 7.24488C1.94744 7.35001 1.94744 7.65005 2.15769 7.75518L3.4641 8.40839C3.51931 8.43599 3.56407 8.48075 3.59168 8.53596L4.24488 9.84237C4.35001 10.0526 4.65005 10.0526 4.75518 9.84237L5.40839 8.53596C5.43599 8.48075 5.48075 8.43599 5.53596 8.40839L6.84237 7.75518C7.05262 7.65005 7.05262 7.35001 6.84237 7.24488L5.53596 6.59168C5.48075 6.56407 5.43599 6.51931 5.40839 6.4641L4.75518 5.15769Z" fill="black"/>
	<path d="M9.26447 2.16345C9.1555 1.94552 8.8445 1.94552 8.73553 2.16345L8.25558 3.12335C8.22697 3.18057 8.18057 3.22697 8.12335 3.25558L7.16345 3.73553C6.94552 3.8445 6.94552 4.1555 7.16345 4.26447L8.12335 4.74442C8.18057 4.77303 8.22697 4.81943 8.25558 4.87665L8.73553 5.83655C8.8445 6.05448 9.1555 6.05448 9.26447 5.83655L9.74442 4.87665C9.77303 4.81943 9.81943 4.77303 9.87665 4.74442L10.8365 4.26447C11.0545 4.1555 11.0545 3.8445 10.8365 3.73553L9.87665 3.25558C9.81943 3.22697 9.77303 3.18057 9.74442 3.12335L9.26447 2.16345Z" fill="black"/>
	<path d="M18.7551 15.1577C18.65 14.9474 18.35 14.9474 18.2449 15.1577L17.5917 16.4641C17.5641 16.5193 17.5193 16.5641 17.4641 16.5917L16.1577 17.2449C15.9474 17.35 15.9474 17.65 16.1577 17.7551L17.4641 18.4083C17.5193 18.4359 17.5641 18.4807 17.5917 18.5359L18.2449 19.8423C18.35 20.0526 18.65 20.0526 18.7551 19.8423L19.4083 18.5359C19.4359 18.4807 19.4807 18.4359 19.5359 18.4083L20.8423 17.7551C21.0526 17.65 21.0526 17.35 20.8423 17.2449L19.5359 16.5917C19.4807 16.5641 19.4359 16.5193 19.4083 16.4641L18.7551 15.1577Z" fill="black"/>
	</svg>
	`,
	},
];
